<div class="d-flex justify-content-center flex-column align-items-center">
    <div class="not-found-image"></div>
    <span class="not-found-text">
        <strong>{{message}}</strong>
    </span>
</div>
